<template>
	<div class="row" v-if="filter_data">
		<div class="col-md-12">
			<fieldset>
				<div class="field-title mb-2">
					<div class="legend">Filtro</div>
				</div>

				<div class="container-fluid">
					<div class="row">
						<div class="col-md-6 col-xl-3">
							<div class="form-group">
								<label>Identificador</label>
								<select class="form-control form-control-sm" v-model="identificador" @change="update_type">
									<option v-for="(fil, index) in filter_data" :key="index" :value="index">Filtrar por {{ fil.label }}</option>
								</select>
							</div>
						</div>

						<div class="col-md-6">
							<div class="form-group">
								<label for="toID">Valor</label>

								<input v-if="type == 'text'"  v-model="value" @keyup.enter="set_filter" type="text" class="form-control form-control-sm">

								<input v-else-if="type == 'phone'" v-model="value" @keyup.enter="set_filter" type="text" class="form-control form-control-sm">
								
								<date-range-picker 
                                    class="date-range"
                                    v-else-if="type == 'date'"
                                    ref="picker"
                                    :locale-data="{ firstDay: 1, format: 'DD/MM/YYYY HH:mm' }"
                                    :timePicker="true"
                                    :timePicker24Hour="true"
                                    :autoApply="false"
                                    v-model="dateRange"
                                    @update="update_date"
                                />
								<transition mode="out-in" name="leftIn" v-else-if="type == 'select'">
									<select v-model="value" @change="set_filter" v-if="select_data" class="form-control form-control-sm">
										<option v-for="(opt, index) in select_data" :key="index" :value="( opt.id ) ? opt.id : opt.ID">
											<span v-if="opt.nome">{{ opt.nome }}</span>
											<span v-else-if="opt.name">{{ opt.name }}</span>
											<span v-else>{{ opt.NAME }}</span>
										</option>
									</select>

									<div v-else><Loading/></div>
								</transition>

								<input  v-else readonly v-model="value" type="text" class="form-control form-control-sm">
							</div>
						</div>

						<div v-if="!hidden_search" class="col-md-9 col-xl-5">
							<div class="form-group">
								<label style="color: #F8F9FC">.</label>
								<input class="form-control form-control-sm" type="text" placeholder="Procurar na lista.." v-model="search" @keypress="search_list">
							</div>
						</div>

						<div v-if="!hidden_search" class="col-md-3 col-xl-1">
							<div class="form-group">
								<label style="color: #F8F9FC">.</label>
								<div class="form-control form-control-sm btn btn-sm btn-info" @click="clear">Limpar</div>
							</div>
						</div>

						<div v-if="show_btn" class="col-2">
							<div class="form-group">
								<label style="color: #F8F9FC">.</label>
								<button class="form-control form-control-sm btn btn-sm btn-primary" @click="set_filter">Filtrar</button>
							</div>
						</div>
					</div>
				</div>
			</fieldset>
		</div>
	</div>
</template>

<script>
	import api 	   from "@/mixins/api.js"
	import replace from "@/mixins/replace.js"
	
	import DateRangePicker  from 'vue2-daterange-picker'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

	export default {
		name: "filtros",
		props: ['filter_data', 'hidden_search', 'show_btn'],
		mixins: [api, replace],
        components: { DateRangePicker },

		data() { 
			return {
				identificador: null,
				type: null,
				filter: null,
				value: null,
				operador: null,
				select_data: null,
				dateRange: { startDate: this.$moment(Date()).format("Y-MM-01 00:00"), endDate: this.$moment(Date()).format("Y-MM-30 23:59") },
				search: ""
			}
		},

		methods: {
			update_type() {
				const filtro  = this.filter_data[this.identificador];
				this.value    = null;
				this.type     = filtro.type;
				this.filter   = filtro.name;
				this.operador = filtro.operador;

				if ( filtro.type == "select" ){
					this.get_data(filtro.data_get);
				}
			},

			async get_data(payload) {
				const response = await this.GET(payload);

				if ( response.status == "success" ){
					this.select_data = response.result;
				}else{
					this.select_data = [{ id: 0, nome: "Falha ao buscar dados" }];
				}
			},

			clear() {
				this.identificador = null;
				this.value = null;
				this.type = null;
				this.search = '';
				this.$emit('filtrar', "");
			},

			set_filter() {
				const value  = ( this.type == 'phone' ) ? this.LimpaNum(this.value) : this.value;
				const filter = ( this.operador == 'like' ) ? `&like=${this.filter}&value=${value}` : `&${this.filter}=${value}`;
				this.$emit('filtrar', filter);
			},
            
            update_date() {
                const date_ini = this.$moment(this.dateRange.startDate).format("Y-MM-DD HH:mm");
                const date_fim = this.$moment(this.dateRange.endDate).format("Y-MM-DD HH:mm");
				const filter = `&date_ini=${date_ini}&date_fim=${date_fim}`;
				this.$emit('filtrar', filter);
            },

			search_list() {
				const value = this.search.toLowerCase();
				const rows  = document.getElementsByTagName("tr");

				for (let i = 0; i < rows.length; i++){
			        const txtValue = rows[i].textContent || rows[i].innerText;

			        if ( txtValue.toLowerCase().indexOf(value) > -1 ){
			        	rows[i].style.display = "";
			        }else{
						rows[i].style.display = "none";
					}
			    }
			},
		}
	}
</script>

<style>
	fieldset { 
		border:2px solid #147F75; 
		-moz-border-radius:8px; 
		-webkit-border-radius:8px;
		border-radius:8px; 
		margin-bottom: 10px
	}

	.field {
		margin-bottom: 10px;
	}

	.legend { 
		margin-left:16px;
	}

	.field-title { 
		width: 100%;
		height: 50px;
		line-height: 50px; 
		background-color: rgba(220, 220, 220, 0.7);
		border-radius: 8px 8px 0 0 
	}

	.field-title button {
		margin-right: 10px;
	}

	.field-fot { 
		width: 100%;
		height: 50px; 
		line-height: 50px; 
		background-color: rgba(220, 220, 220, 0.7); 
		border-radius: 0 0 8px 8px; 
	}

	.field-content { 
		padding:16px; 
	}

	.field-fot .btn { 
		margin-right: 16px 
	}

	.field-fot .btn:hover { 
		background-color: #B2B2B2; 
		color: white 
	}
</style>